export default "__VITE_PUBLIC_ASSET__823707ae__"